<template>
  <table class="table table-borderless table-sm tableTotalPriceOfProducts">

    <tr v-for="prod in getNonSeatProducts" :key="prod.code">
      <td class="check" style="width: 10px;"> <i class="fa fa-check text-secondary"></i></td>
      <td class="nameType">{{ productName(prod) }}:</td>
      <td class="text-right price ">
        {{ store.priceFilter(getProductPrice(prod)) }}
      </td>
    </tr>
    <tr v-for="seat in getSeatProduct">
      <td class="check" style="width: 10px;"> <i class="fa fa-check text-secondary"></i></td>
      <td class="nameType">
        {{ t('total.virtualSeat') }} {{ t('years.m'+seat.months) }}:
        <span v-if="profile.showSalePromo && seat.months === '12' && seat.firstYearWebDiscountPercent"
              class="badge badge-secondary rounded">
          <s>{{ seat.totalPriceWithoutVatNoSaleFilter }}</s>
          | {{ t('sale') }} {{ seat.firstYearWebDiscountPercent }} % {{ t('na') }} 1. {{ t('year') }}
        </span>
      </td>
      <td class="text-right price ">
        {{store.priceFilter(seat.totalPriceWithoutVat)}}
      </td>
    </tr>

  </table>
</template>

<script>
import {store} from "../store.js";
import {useI18n} from "vue-i18n";
import {useLocaleProfile} from "@/composables/useLocaleProfile";
import {useProductName} from "@/composables/useProductName";
import {ref} from 'vue'

export default {
  name: "TotalPriceOfProducts",
  data() {
    return {
      store,
      priceProducts: {
        spravniPoplatek: {}
      }
    }
  },
  setup() {
    const {t,locale} = useI18n({useScope: 'global'})
    const {profile} = useLocaleProfile()
    const {productName} = useProductName()
    const select = ref(0)
    const lang = locale
    return {t, select, lang, profile, productName}
  },
  computed: {

    getSpravniPoplatek() {
      var prod = this.store.getOrderProduct('ZU01');
      // console.log(prod);
      this.priceProducts.spravniPoplatek =prod;
      return prod;
    },
    getSeatProduct() {
      return this.store.getSeatProduct();
    },
    getNonSeatProducts() {
      return this.store.order.products.filter(p => p.type !== 'seat');
    },
  },
  methods: {
    // Správní poplatek se i v korunové mutaci bere z ceníku, ne ze standardPrice —
    // zachovává se tím výpočet, který měl vlastní řádek košíku před sloučením do smyčky.
    getProductPrice(prod) {
      if (prod.code === 'ZU01') return this.store.getPriceSpravniPoplatek();
      return prod.totalPriceWithoutVat;
    },
  }

}
</script>

<style lang="scss" scoped>
.price {

}
.nameType {

}
.tableTotalPriceOfProducts {
  td {
    font-size: 14px;
  }
}
</style>